import request from '@/utils/request'

export function sendWelcome(data) {
  return request({
    url: '/app/socket/sendWelcome',
    method: 'post',
    data
  })
}

export const history = (data) => {
  return request({
    method: "get",
    url: "/app/messages/list",
    params:data
  })
}

export const chatMessagesSend = (data) => {
  return request({
    method: "post",
    url: "/app/messages",
    data:data
  });
}

export function imageUploader(data) {
  return request({
    // url: '/app/messages/imageUploader',
    url: '/system/oss/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  })
}

